// Map icon paths
export const LIGHTNING_RECENT = '/images/map/lightning_5min.png';
export const LIGHTNING_MEDIUM = '/images/map/lightning_30min.png';
export const LIGHTNING_OLD = '/images/map/lightning_old.png';
export const USER_LOCATION = 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png';
